


function paged() {

    $('#shopify-section-recipes-listing').on('click', 'li .page-d', function () {


        var target = $(this).attr('data-page');
        var current = $('nav.nav-p-d li.active span').attr('data-page');

        var limit = $(this).parents('ol').attr('data-pagecount')

        var pageclass = 'page_' + target;

        $('#shopify-section-recipes-listing').find('.recipe_item').hide()
        $('#shopify-section-recipes-listing').find('.recipe_item.' + pageclass).show()

        $('#shopify-section-recipes-listing').find('.pagination li').removeClass('active')

        $(this).parent().addClass('active')

        $('#shopify-section-recipes-listing').find('.pagination li').find('.page-d[data-page="' + target + '"]').parent().addClass('active')


        $('html, body').animate({
            scrollTop: $("#shopify-section-recipes-listing").offset().top - 50
        }, 400);

        var next = (parseInt(target) <= parseInt(limit)) ? parseInt(target) : (parseInt(target) + 1);
        var prev = (parseInt(target) >= 0) ? parseInt(target) : (parseInt(target) - 1);

        $('#shopify-section-recipes-listing')
            .find('.pagination li.next-page .page-d').attr('data-page', next)


        $('#shopify-section-recipes-listing')
            .find('.pagination li.prev-page .page-d').attr('data-page', prev)


    })



}


function fixedSocialIcons() {
    var target_container = $('#shopify-section-footer .container');
    var offset_right = $(target_container).offset().left + $(target_container).outerWidth() + 55
    var or = offset_right + 'px';


    $('#social-icons-fixed').css('left', or)

}

document.addEventListener("DOMContentLoaded", function () {

    $('.qty_up_cart').on('click', function () {
        console.log('qty')
        var current_qty = $(this).siblings('.qty__input_cart').val()
        var next_qty = parseInt(current_qty) + 1

        $(this).siblings('.qty__input_cart').val(next_qty).attr('value', next_qty).trigger('change')
    })

    $('body').on('click', '.qty_down_cart', function () {
        var current_qty = $(this).siblings('.qty__input_cart').val()
        var next_qty = parseInt(current_qty) - 1

        $(this).siblings('.qty__input_cart').val(next_qty).attr('value', next_qty).trigger('change')
    })



    $('.qty__input_cart').on('change', function () {
        var qty = $(this).val();
        var vid = $(this).attr('data-vid');

        $.post('/cart/change.js', {
            'id': vid,
            'quantity': qty
        }).then(function () {
            window.location = window.location;
        })

    })


    $('body').on('click', '.qty_up', function () {
        var $input = $(this).siblings('.qty__input');
        var current_qty = parseInt($input.val());
    var max_qty = parseInt($input.attr('max'));
    var next_qty = current_qty + 1;

    if (next_qty <= max_qty) {
        $input.val(next_qty).trigger('change').attr('value', next_qty);
    } else {
        $('#product-qty-limit').text(`Maximum quantity available: ${max_qty}`);
        console.log(`Maximum quantity of ${max_qty}`);
    }
});

$('body').on('click', '.qty_down', function () {
    var $input = $(this).siblings('.qty__input');
    var current_qty = parseInt($input.val());
    var min_qty = parseInt($input.attr('min')) || 1; // Default to 1 if no min is set
    var next_qty = current_qty - 1;

    if (next_qty >= min_qty) {
        $input.val(next_qty).trigger('change').attr('value', next_qty);
    } else {
        console.log(`Minimum quantity of ${min_qty} reached`);
    }
});




    paged()

    fixedSocialIcons()

    $('.accordion-collapse').on('shown.bs.collapse', function () {
        var text = $(this).html()
    })

    $('body').on('click', '.search-collapse', function () {

        var ss = $('#search_pop').hasClass('show');

        setTimeout(function () {
            $('#search_pop').find('input[type="text"]').focus();

        }, 400)



    })


    $('.navbar-collapse').on('shown.bs.collapse', function () {
        $('body').addClass('navbar-open')
    })



    $('.navbar-collapse').on('hide.bs.collapse', function () {
        $('body').removeClass('navbar-open')
        $('body').removeClass('nav-subopen')
    })

    $('.nav-item.has-megamenu > a').on('click', function (e) {
        var ww = $(window).width()

        $('li.nav-item').removeClass('lishow')

        if (ww < 992) {
            e.preventDefault()
            $('body').addClass('nav-subopen')
            $(this).parent().addClass('lishow')


        }


    })






    $('#redemDevPromo').on('click', function (event) {
        event.preventDefault();
        var theUrl = '/cart?discount=';
        var theDiscount = $('#devPromo').val();
        var toRedirect = theUrl + theDiscount;
        window.location.href = toRedirect;
    });



    $('#menu_back').on('click', function (e) {

        var ww = $(window).width()

        if (ww < 992) {
            e.preventDefault()
            $('body').removeClass('nav-subopen')
        }

    })



    window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
            document.getElementById('body').classList.add('scrolled');
            document.getElementById('navbar').classList.add('fixed-top');

            navbar_height = document.querySelector('.navbar').offsetHeight;
            document.body.style.paddingTop = navbar_height + 'px';
        } else {
            document.getElementById('body').classList.remove('scrolled');
            document.getElementById('navbar').classList.remove('fixed-top');
            document.body.style.paddingTop = '0';
        }

        $('.megamenu').removeClass('show')
        $('#search_pop').removeClass('show')
        $('button[data-bs-target="#search_pop"]').attr('aria-expanded', 'false')
        $('.boost-pfs-search-suggestion-wrapper').removeClass('boost-pfs-search-suggestion-open')

    });



    $('li.nav-item.dropdown.has-megamenu').on('mouseenter', function () {
        var link = $(this).find('.nav-link.dropdown-toggle')
        var menu = $(this).find('.dropdown-menu.megamenu')


        var ww = $(window).width()

        if (ww >= 992) {

            $(link).attr('aria-expanded', 'true').addClass('show')
            $(menu).addClass('show')

        }

    })

    $('li.nav-item.dropdown.has-megamenu').on('mousemove', function () {
        var link = $(this).find('.nav-link.dropdown-toggle')
        var menu = $(this).find('.dropdown-menu.megamenu')



        var liBounds = this.getBoundingClientRect();
        var mouseX = event.clientX;
        var mouseY = event.clientY;
    
        var isOverLi = mouseX >= liBounds.left && mouseX <= liBounds.right && mouseY >= liBounds.top && mouseY <= liBounds.bottom;
    
        var ww = $(window).width();
    
        if (isOverLi && ww >= 992) {
            $(link).attr('aria-expanded', 'true').addClass('show');
            $(menu).addClass('show');
        }

    })


    $('li.nav-item.dropdown.has-megamenu').on('mouseleave', function () {
        var link = $(this).find('.nav-link.dropdown-toggle')
        var menu = $(this).find('.dropdown-menu.megamenu')

        var ww = $(window).width()

        if (ww >= 992) {

            $(link).attr('aria-expanded', 'false').removeClass('show')
            $(menu).removeClass('show')

        }

    })

    $('li.nav-item.dropdown.has-megamenu .dropdown-menu.about-dropdown > .container > .row').on('mouseleave', function () {

        console.log('leave')
        var link = $(this).parents('li.has-megamenu').find('.nav-link.dropdown-toggle')
        var menu = $(this).parents('li.has-megamenu').find('.dropdown-menu.megamenu')

        var ww = $(window).width()

        if (ww >= 992) {

            $(link).attr('aria-expanded', 'false').removeClass('show')
            $(menu).removeClass('show')

        }

    })

    const secondaryMenuParents = [...document.querySelectorAll('[data-js-secondary-menu-parent]')];

    if (secondaryMenuParents.length > 0) {
        secondaryMenuParents.forEach(secondaryMenuParent => {
            const secondaryMenuChild = secondaryMenuParent.querySelector('[data-js-secondary-menu-child]');
            const secondaryMenuAnchor = secondaryMenuParent.querySelector('[data-js-secondary-menu-anchor]');
            secondaryMenuParent.addEventListener('mouseover', (event) => {
                secondaryMenuChild.classList.remove('tw-hidden');
            });
            secondaryMenuParent.addEventListener('mouseout', (event) => {
                secondaryMenuAnchor.addEventListener('mouseover', (event) => {
                    return;
                });
                secondaryMenuChild.addEventListener('mouseover', (event) => {
                    return;
                });
                secondaryMenuChild.classList.add('tw-hidden');
            });
        });
    }

    $('.dropdown-menu.megamenu.show').on('mouseleave', function () {
        var link = $(this).parent().find('.nav-link.dropdown-toggle')
        var menu = $(this).parent().find('.dropdown-menu.megamenu')

        var ww = $(window).width()

        if (ww >= 992) {


            $(link).attr('aria-expanded', 'false').removeClass('show')
            $(menu).removeClass('show')

        }




    })






    $('body').on('submit', 'form[action="/checkout"]', function (e) {
        e.preventDefault();
        setTimeout(function () {
            var sp_error = $('#storePickupApp').find('.error:visible').length;

            if (sp_error < 1) {
                window.location = '/checkout';
            }
        }, 1000)

    })







    $('button#postcode-search').on('click', function () {

        var input = $('#postcode-input').val()
        var postcode = input.toUpperCase();

        var available = ($('span[data-postcode="' + postcode + '"]').length) ? true : false;

        var result_text = (available == true) ? 'Yes we deliver to ' + postcode : 'No, sorry we don\'t deliver to ' + postcode;

        if (input.length > 1) {
            $('#postcode-result').text(result_text)
        } else {
            $('#postcode-result').text('Enter at least 2 characters')
        }

    })





    $('body').on('click', '[data-dismiss="modal"]', function () {

        myModal.hide()

    })



})




function filtertag(blockid) {

    var el = blockid;

    var active = $(el).hasClass('filter-active')
    var target = $(el).attr('data-filter')

    console.log(target)

    if (active) {

    } else {

        if (target == 'all') {
            $('.custom-blog-listing [id^="block_"]').show()

        } else {
            $('.custom-blog-listing [id^="block_"]').hide()
            $('.custom-blog-listing [id="' + target + '"]').show()
        }

        $('.filter-tag[data-filter]').each(function () {
            $(this).removeClass('filter-active')
        })


        $(el).addClass('filter-active')

        $('html, body').animate({
            scrollTop: $("#anchor-target").offset().top - 50
        }, 200);


    }

}



$('body').on('click', 'li.active', function () {


    // var target = $(this).attr('data-page');
    // var current = $('nav.nav-p-d li.active a').attr('data-page');




});


$('body').on('click', '.filter-tag', function () {
    var active = $(this).hasClass('filter-active')
    var target = $(this).attr('data-filter')

    console.log(target)

    if (active) {

    } else {

        if (target == 'all') {
            $('.custom-blog-listing [id^="block_"]').show()

        } else {
            $('.custom-blog-listing [id^="block_"]').hide()
            $('.custom-blog-listing [id="' + target + '"]').show()
        }

        $('.filter-tag[data-filter]').each(function () {
            $(this).removeClass('filter-active')
        })


        $(this).addClass('filter-active')

        $('html, body').animate({
            scrollTop: $("#anchor-target").offset().top - 50
        }, 1000);


    }



})






window.addEventListener('resize', function () {

    fixedSocialIcons()

});


function buildQuickView(product_handle) {

    var icon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12.428" viewBox="0 0 20 12.428">
    <defs>
      <style>
        .cls-1-eye {
          fill: #fff;
        }
      </style>
    </defs>
    <g id="noun_Eye_2037681" transform="translate(-2.525 -20.5)">
      <g id="Group_4259" data-name="Group 4259" transform="translate(2.525 20.5)">
        <g id="Group_4258" data-name="Group 4258" transform="translate(0 0)">
          <path id="Path_4806" data-name="Path 4806" class="cls-1-eye" d="M22.383,26.271c-.169-.232-4.444-5.771-9.858-5.771s-9.689,5.54-9.858,5.771a.727.727,0,0,0,0,.864c.169.253,4.444,5.793,9.858,5.793s9.689-5.54,9.858-5.771A.759.759,0,0,0,22.383,26.271Zm-9.858,5.2c-3.876,0-7.267-3.518-8.341-4.76,1.074-1.264,4.444-4.76,8.341-4.76,3.876,0,7.267,3.518,8.341,4.76C19.792,27.978,16.422,31.474,12.525,31.474Z" transform="translate(-2.525 -20.5)"/>
          <path id="Path_4807" data-name="Path 4807" class="cls-1-eye" d="M37.573,34.4a3.394,3.394,0,1,0,3.173,3.387A3.289,3.289,0,0,0,37.573,34.4Zm0,5.275a1.893,1.893,0,1,1,1.769-1.889A1.833,1.833,0,0,1,37.573,39.675Z" transform="translate(-27.573 -31.573)"/>
        </g>
      </g>
    </g>
  </svg>`;

    var html = '<a onclick="showQuickView(`' + product_handle + '`)" class="btn quickview bg-primary position-absolute z-front bottom-0 end-0" data-product="' + product_handle + '">' + icon + '</a>';
    return html;
}





function showQuickView(handle) {
    var myModal = new bootstrap.Modal(document.getElementById('quickViewModal'), {
        keyboard: false
    });

    $('#quickViewModal .modal-body').load('/products/' + handle + '?view=quickview', function () {
        myModal.show();

        const container = $('#quickview-' + handle);
        const variant_id = container.find('.variant-id').val();  
        const variant_available = container.find('.variant-available').val();  
        const inv_qty = container.find('.qty__input').data('inv') || 9999; 

        $.getJSON('/cart.js', function (cart) {
            checkLimits(cart, variant_id, variant_available);
        });
    });
}


function closemodal(id) {


    $('#' + id).modal('hide')

}

function checkLimits2(cart, variant_id) {

    const variantCounts = {};

    // Calculate totals grouped by variant_id
    cart.items.forEach(function (item) {
        if (variantCounts[item.variant_id]) {
            variantCounts[item.variant_id] += item.quantity;
        } else {
            variantCounts[item.variant_id] = item.quantity;
        }
    });

    console.log("Variant Counts:", variantCounts);

    const totalItemCount = Object.values(variantCounts).reduce((a, b) => a + b, 0);
    console.log("Total Item Count:", totalItemCount);

    const quantityInput = $('.qty__input:visible');

    // Maximum items allowed per variant_id
    const maxCanAdd = $(quantityInput).attr('data-maxcanadd') || 999999;

    // Get the count for the current variant_id
    const currentVariantCount = variantCounts[variant_id] || 0;

    const remainingQuantity = Math.max(maxCanAdd - currentVariantCount, 0);

    // Update cart count display
    $('.cart-count').each(function () {
        $(this).html(totalItemCount);
    });

    if (quantityInput.length) {
        quantityInput.attr('max', remainingQuantity);
        if (quantityInput.val() > remainingQuantity) {
            quantityInput.val(remainingQuantity); // Ensure value is within limit
        }
    }

    // Check if the current variant_id count exceeds maxCanAdd
    if (currentVariantCount >= maxCanAdd) {
        $('#product-add-to-cart').attr('disabled', true).text(`Limit Reached (${maxCanAdd})`);
        $('[data-quickadd]').attr('disabled', true).text(`Limit Reached (${maxCanAdd})`);
        
    } else {
        $('#product-add-to-cart').attr('disabled', false).text('Add to Basket');
        $('[data-quickadd]').attr('disabled', false).text('Add to Basket');
    }

    // Return calculated data
    return { variantCounts, totalItemCount, currentVariantCount };
}


function addToCartOk(handle,variant_id) {



    setTimeout(function () {
        $.getJSON('/cart.js', function (cart) {

            $('#quickViewModal .modal-body').load('/products/' + handle + '?view=quickview', function () {
                $('.modal-content button[data-form]').html('Add to Basket');
                $('.modal-content .error').html('');
                $('.modal-content select[name="id"]:visible').val(variant_id).trigger('change');
                $('input.qty__input:visible').val(1).trigger('change');
                $('.modal-content .success').html('Successfully added to <a href="/cart">basket</a>!');
            });

            $('#product-add-error').html('');
            $('#product-add-success').html('Successfully added to <a href="/cart">basket</a>!');
            $('#product-add-to-cart').html('Add to Basket');
        });
    }, 1000);

    setTimeout(function () {
        $('.modal-content .success').html('');
    }, 12000);

    setTimeout(function () {
        $.getJSON('/cart.js', function (cart) {
            checkLimits(cart, variant_id);
        });
    },1200)


}




function addToCartFail(obj, status) {
    $('.modal-content button[data-form]').html('Add to Basket')
    $('#product-add-to-cart').html('Add to Basket')


    $('.modal-content .success').html('')
    $('.modal-content .error').html('Error')

    $('#product-add-error').html('')
    $('#product-add-success').html('Error')

}


function addItem(form_id, handle) {

    $('.modal-content button[data-form]').html('Adding...')
    $('#product-add-to-cart').html('Adding...')
    var variant_id = $('#' + form_id).find('select[name="id"]').val();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + form_id)
            .serialize(),
        success: addToCartOk(handle,variant_id),
        error: addToCartFail
    });
}



function quickAdd(form_id, handle) {
    var qty = $('input.qty__input:visible').val();
    if (qty > 0){
        addItem(form_id, handle)
    }
}


$(window).on('load', function () {




    $('.boost-pfs-filter-product-item.boost-pfs-filter-product-item-grid').each(function () {

        var product_handle = $(this).find('a').attr('href').split('/products/')[1];

        var quickView = buildQuickView(product_handle);

        var target = $(this).find('.boost-pfs-filter-product-item-inner')
        $(quickView).appendTo(target)

    })


    const swiper_highlights = new Swiper('.swiper-container.swiper-highlights', {

        // Optional parameters
    
        slidesPerView: 1.25,
        centeredSlides: false,
    
        breakpoints: {
          768: {
            centeredSlides: false,
    
            slidesPerView: 3
          },
          992: {
            slidesPerView: 3,
            centeredSlides: false
      
          }
        },
    
    
        // If we need pagination
        pagination: {
          el: '.swiper-pagination'
        },
    
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
    
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar'
        }
      });





})



$('body').on('click', '#product-add-to-cart:not[disabled]', function (e) {
    console.log('addddd')
    e.preventDefault();
    var form_id = $(this).attr('data-form')
    var handle = $(this).attr('data-producthandle')
    addItem(form_id, handle)

})

document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function (event) {
        var priceElement = event.target.closest('.boost-pfs-filter-product-item-price');

        if (priceElement) {
            var linkElement = getPreviousSibling(priceElement, 2);

            if (linkElement && linkElement.tagName === 'A') {
                window.location.href = linkElement.href;
            }
        }
    });

    function getPreviousSibling(element, n) {
        for (var i = 0; i < n; i++) {
            element = element.previousElementSibling;
        }
        return element;
    }
});

$(document).ready(function(){
    $(".modal_logout").click(function(){
        $("#modal_logout").show();
    });
    $(".modal_logout_close").click(function(){
        $("#modal_logout").hide();
    });
    $(window).click(function(event){
        if (event.target.id == "modal_logout") {
            $("#modal_logout").hide();
        }
    });
});